"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _breakbox = require("../breakbox");

var Box = (0, _breakbox.breakbox)({
  displayName: 'Breakbox(Box)'
});
var _default = Box;
exports.default = _default;